<nav
  id="spy-nav-bar"
  class="navbar flex-column align-items-stretch w-100 px-2"
  style="box-shadow: none; background-color: transparent"
>
  <nav class="nav flex-column">
    <ng-container *ngFor="let item of navigationListItems">
      <div
        class="scroll-nav-link nav-list-item mb-2"
        (click)="scrollTo(item.id)"
        [ngClass]="{ 'current-section': currentSection === item.id }"
      >
        {{ prefix + item.label | msg | async }}
      </div>
    </ng-container>
  </nav>
</nav>
